"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kycLevelFormSelector = void 0;
exports.kycLevelFormSelectorCallback = kycLevelFormSelectorCallback;
exports.kycVerificationLevelsSelector = void 0;
var _reselect = require("reselect");
var _get = _interopRequireDefault(require("lodash/get"));
var _config = _interopRequireDefault(require("../../config"));
var _verificationRequiredHelper = require("../../helpers/verificationRequiredHelper");
var _arrayHelper = require("../../helpers/arrayHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var kycVerificationLevelsSelector = exports.kycVerificationLevelsSelector = (0, _reselect.createSelector)([function (state) {
  return state.user.selectedAccountId;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}], function (AccountId, accounts, userConfig) {
  var _ref = accounts.find(function (account) {
      return account.AccountId === AccountId;
    }) || {},
    verificationLevel = _ref.VerificationLevel;
  var kycConfig = (0, _get["default"])(_config["default"], 'KYC', {});
  var levelIncreaseStatus = (userConfig.find(function (config) {
    return config.Key === 'levelIncreaseStatus';
  }) || {}).Value;
  levelIncreaseStatus = kycConfig.type === 'Manual' ? Number(levelIncreaseStatus) : levelIncreaseStatus;
  var _getVerifiedToTradeSt = (0, _verificationRequiredHelper.getVerifiedToTradeStatus)(verificationLevel, levelIncreaseStatus),
    isUnderReview = _getVerifiedToTradeSt.isUnderReview,
    disableTrading = _getVerifiedToTradeSt.disableTrading;
  var disableWithdraw = verificationLevel < _config["default"].Withdraw.MinimumVerificationLevel;
  var disableDeposit = verificationLevel < _config["default"].Deposit.MinimumVerificationLevel;
  return {
    kycConfig: kycConfig,
    levelIncreaseStatus: levelIncreaseStatus,
    verificationLevel: verificationLevel,
    disableTrading: disableTrading,
    isUnderReview: isUnderReview,
    disableWithdraw: disableWithdraw,
    disableDeposit: disableDeposit
  };
});
var kycLevelFormSelector = exports.kycLevelFormSelector = (0, _reselect.createSelector)([function (state) {
  return state.apiProcessing;
}, function (state) {
  return state.user.userInfo;
}, function (state) {
  return state.user.accounts;
}, function (state) {
  return state.user.userConfig;
}, function (state) {
  return state.user.kyc;
}, function (state) {
  return state.auth.token;
}], kycLevelFormSelectorCallback);
function kycLevelFormSelectorCallback(apiProcessing, userInfo, accounts, userConfig, kyc, token) {
  var AccountId = userInfo.AccountId,
    UserId = userInfo.UserId,
    userName = userInfo.UserName,
    email = userInfo.Email;
  var levelIncreaseStatus = (userConfig.filter(function (config) {
    return config.Key === 'levelIncreaseStatus';
  })[0] || {}).Value;
  var _ref2 = accounts.filter(function (account) {
      return account.AccountId === AccountId;
    })[0] || {},
    verificationLevel = _ref2.VerificationLevel;
  var kycConfig = (0, _get["default"])(_config["default"], 'KYC', {});
  var processing = kycConfig.type === 'Manual' ? apiProcessing.processingSetUserConfig : apiProcessing.processingValidateUserRegistration;
  var levelIncreaseStatusIndex = (0, _arrayHelper.findIndexOfObject)(userConfig, 'Key', 'levelIncreaseStatus');
  return {
    alphaPointSessiontoken: token,
    alphaPointUserID: UserId + '',
    userConfig: userConfig,
    userName: userName,
    email: email,
    verificationLevel: verificationLevel,
    levelIncreaseStatus: levelIncreaseStatus,
    kycConfig: kycConfig,
    kyc: kyc,
    processing: processing,
    levelIncreaseStatusIndex: levelIncreaseStatusIndex
  };
}